import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowBanner(true);
      setTimeout(() => setShowBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
      // The persistent offline bar is owned by OfflineBanner.
      // Rendering it here too stacked two amber bars on top of each other.
      setShowBanner(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!showBanner || !isOnline) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[10000] px-4 py-3 text-center text-sm font-medium transition-transform duration-300 ${
        isOnline
          ? 'bg-emerald-500 text-white translate-y-0'
          : 'bg-amber-500 text-white translate-y-0'
      }`}
    >
      <div className="flex items-center justify-center gap-2">
        {isOnline ? (
          <>
            <Wifi className="h-4 w-4" />
            <span>Du er nu online igen</span>
          </>
        ) : (
          <>
            <WifiOff className="h-4 w-4" />
            <span>Du er offline. Tjek din internetforbindelse.</span>
          </>
        )}
      </div>
    </div>
  );
}

